import Vue from 'vue'
import template from './product_movement.pug'

const PRODUCT_TYPES = [13, 14, 16]
const TYPE_CHARGE = 15
const TYPE_RECHARGE = 16
const TYPE_VALIDATION = 13
const TEMPORARY_REVENUE_CLASSES = [
  'temporary_pass',
  'tourist_pass',
  'one_way_ticket'
]
const TRIP_REVENUE_CLASSES = [
  'prepurchased_trips'
]

export default Vue.extend({
  name: 'product-movement',
  template: template(),
  props: {
    movimiento: {
      type: Object,
      required: true
    }
  },
  computed: {

    travelBusImage() {
      return require('assets/images/ilustrations/private-area/ticket.svg')
    },

    operationTypeText() {
      if (this.isCharge) {
        return this.$t('movementsHistory.charge')
      }

      return this.isRecharge ? this.$t('movementsHistory.recharge') : this.$t('travels.transactionTypes.flatRate')
    },

    stopInfo() {
      return this.movimiento.stop || {}
    },

    routeColor() {
      if (!this.movimiento.route?.color) return '#000000'

      return `${this.movimiento.route.color}`
    },

    routeDescription() {
      return this.movimiento.route?.description || ''
    },

    routeShortName() {
      return this.movimiento.route?.short_name || ''
    },

    operatorName() {
      return this.movimiento.operator_name || ''
    },

    isCharge() {
      return this.movimiento.type === TYPE_CHARGE
    },
    isValidation() {
      return this.movimiento.type === TYPE_VALIDATION
    },
    isRecharge() {
      return this.movimiento.type === TYPE_RECHARGE
    },

    shouldShowAmount() {
      return !PRODUCT_TYPES.includes(this.movimiento.type) && this.movimiento.amount
    },
    productTravels() {
      // TODO: añadir más items
      return this.$t('movementsHistory.travelItem')
    },
    productMonth() {
      return this.$t('movementsHistory.monthItem')
    },
    productYear() {
      return this.$t('movementsHistory.yearItem')
    },
    productDays() {
      return this.$t('movementsHistory.daysItem')
    },
    productDay() {
      return this.$t('movementsHistory.dayItem')
    },
    displayProductDescription() {
      if (this.movimiento.product_description) {
        return `${this.$t('movementsHistory.product')}: ${this.formatProductDescription()}`
      }

      return ''
    },

    displayAmount() {
      // Si es una recarga siempre se muestra el precio de compra
      if (this.isRecharge) {
        return parseFloat(this.movimiento.buy_price)
      }
      // Si es una carga siempre se muestra el precio de pago
      if (this.isCharge) {
        return parseFloat(this.movimiento.paid_amount)
      }
      // Si es una validación de un producto con viajes precomprados se muestra que se ha gastado un viaje, si es temporal no se muestra nada
      if (this.isValidation) {
        // No hace falta mostrar ni el precio porque son productos temporales o ya comprados.
        // if(TRIP_REVENUE_CLASSES.includes(this.movimiento.revenue_class)){
        //   return '1 ' + this.productTravels
        // }
        return ''
      }

      return parseFloat(this.movimiento.amount)
    },

    productBalaceBefore() {
      return this.movimiento?.balance_before
    },

    productBalaceAfter() {
      // TODO: Si es una validación o recarga no se muestra el saldo final hasta que estemos seguros de que balance_after es correcto del type 13 cuando revenue_class es prepurchased_trips
      return ''

      return this.movimiento?.balance_after || ''
    }

  },

  methods: {
    formatProductDescription() {
      const language = localStorage.getItem('app-language')
      switch (language) {
        case 'es':
          return this.movimiento.product_description.es
        case 'fr':
          return this.movimiento.product_description.fr
        case 'pt':
          return this.movimiento.product_description.pt
        case 'de':
          return this.movimiento.product_description.de
        case 'en':
          return this.movimiento.product_description.en
        default:
          return this.movimiento.product_description
      }
    },
    formattedDate(stringDate) {
      const date = new Date(stringDate)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const month = months[date.getMonth()]
      const day = date.getDate()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${month} ${day} ${hours}:${minutes}`
    }
  }
})
